import React from 'react';
import Appearance from 'styles/Appearance.js';

const FlipChartPrivacyPolicy = () => {

    const lineHeight = 2;
    const spacing = 20;
    const titleColor = Appearance.colors.prominentText();
    const titleWeight = 700;

    const getItems = () => {

        let items = [{
            title: 'Collection of your Personal Information',
            children: [
                'We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be required to provide certain personal information to us when you elect to use the App.  Such personal information consists of, and is limited to, the following:  your first and last name, your mobile phone number, your personal email address, and your residential address. You understand and agree that we may use your information for, among other things, communicating with you in relation to your use of the App. We also may gather additional personal or non-personal information in the future.'
            ]
        },{
            title: 'Use of your Personal Information',
            children: [
                'Global collects and uses your personal information to make the App available to you and monitor its use.',
                'Global may also use your personally identifiable information to inform you of other products or services available from Global and its affiliates.'
            ]
        },{
            title: 'Sharing Information with Third Parties',
            children: [
                'Global does not sell, rent or lease its customer lists to third parties. Global may share information collected through use of the App with the dealership responsible for such use. Dealerships have access to the data that they have requested and are not able to view or share the information available to other dealerships.',
                'Global may, from time to time, contact you on behalf of external business partners about a particular offering that may be of interest to you. In those cases, your unique personally identifiable information (e-mail, name, address, telephone number) is not transferred to the third party. Global may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to Global, and they are required to maintain the confidentiality of your information.',
                'Global may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on Global; (b) protect and defend the rights or property of Global; and/or (c) act under exigent circumstances to protect the personal safety of App users or the public.'
            ]
        },{
            title: 'Automatically Collected Information',
            children: [
                'Information about your computer hardware and software may be automatically collected by Global. This information is for use of the App, to maintain service quality, and to provide general statistics regarding use of the App.'
            ]
        },{
            title: 'Security of your Personal Information',
            children: [
                'Global secures your personal information from unauthorized access, use, or disclosure. Global uses the following methods for this purpose:',
                {
                    title: '- Sensitive Information',
                    children: [
                        'From time to time, we may request sensitive information from a user. Sensitive information, like account passwords, is encrypted using AES-256 encryption. The Advanced Encryption Standard (AES) is a symmetric block cipher that the U.S. government selects to protect classified data. This ensures that account passwords are not readily visible to unauthorized parties.'
                    ]
                },
                {
                    title: '- SSL Protocol',
                    children: [
                        'When personal information (such as a credit card number) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol.'
                    ]
                },
                'We strive to take appropriate security measures to protect against unauthorized access to or alteration of your personal information. Unfortunately, no data transmission over the Internet or any wireless network can be guaranteed to be 100% secure. As a result, while we strive to protect your personal information, you acknowledge that: (a) there are security and privacy limitations inherent to the Internet which are beyond our control; and (b) the security, integrity, and privacy of any and all information and data electronically exchanged between you and us through the App and otherwise cannot be guaranteed.'
            ]
        },{
            title: 'Data Retention and Deletion Policy',
            children: [
                'A user can request that his or her account be closed and his or her personal information be removed. When an account deletion request is accepted, Global will close the user\'s account and remove all identifiable customer information. Global will continue to maintain some information on closed accounts to ensure data integrity across linked entities. Global will no longer have access to the information identifying the person to whom a closed account belonged prior to the de-identification process. The App is required to submit a request for account deletion.'
            ]
        },{
            title: 'Children Under Thirteen',
            children: [
                'Global does not knowingly collect personally identifiable information from children under the age of thirteen. If you are under the age of thirteen, you have no reason to use the App and should not use it.'
            ]
        },{
            title: 'E-mail Communications',
            children: [
                'From time to time, Global may contact you via email for the purpose of providing announcements, promotional offers, alerts, confirmations, surveys, and/or other general communications.'
            ]
        },{
            title: 'External Data Storage Sites',
            children: [
                'We may store your data on servers provided by third party hosting vendors with whom we have contracted.'
            ]
        },{
            title: 'Changes to this Statement',
            children: [
                'Global reserves the right to change this Privacy Policy from time to time. We will notify you about significant changes in the way we treat personal information by sending a notice to the primary email address specified in your account, by placing a prominent notice on our site, and/or by updating or otherwise revising this Privacy Policy. Your continued use of the App after such modifications will constitute your: (a) acknowledgment of the modified Privacy Policy; and (b) agreement to abide and be bound by that Policy.'
            ]
        }];

        return items.map(getItemComponent);
    }

    const getItemComponent = (item, index) => (
        <span 
        key={index}
        style={{
            ...Appearance.textStyles.title(),
            display: 'block',
            whiteSpace: 'normal',
            marginTop: spacing,
            lineHeight: lineHeight
        }}>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
            }}>
                {item.title}
            </span>
            
            {item.children.map((child, index) => {
                if(typeof(child) === 'string') {
                    return child;
                }
                return (
                    <div style={{
                        marginBottom: spacing,
                        paddingLeft: 24,
                        width: '100%'
                    }}>
                        {getItemComponent(child, index)}
                    </div>
                )
            })}
        </span>
    )

    return (
        <>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
        }}>
            <span style={{
                ...Appearance.textStyles.header({ color: Appearance.colors.prominentText() }),
                marginBottom: spacing
            }}>{'FlipChart App Privacy Policy'}</span>
        </div>

        <span style={{
            ...Appearance.textStyles.title(),
            display: 'block',
            whiteSpace: 'normal',
            marginBottom: spacing,
            lineHeight: lineHeight
        }}>
            {'Protecting your private information is our priority. This Privacy Policy applies to the FlipChart application (the “App”) and governs data collection and usage. The App is exclusively designed and intended for use by authorized dealers of products manufactured by Global Health & Safety, LLC (“Global”) and by their contracted safety advisors and other personnel.  The App provides informational screens which may be used and/or displayed during the process of making in-home product and service presentations to potential customers. By using the App, you consent to the data practices described in this statement. The App is owned and made available by Global.'}
        </span>

        {getItems()}

        <span style={{
            ...Appearance.textStyles.title(),
            display: 'block',
            whiteSpace: 'normal',
            marginTop: spacing,
            lineHeight: lineHeight
        }}>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
            }}>{'Contact Information'}</span>

            {'Global welcomes your questions or comments regarding this Privacy Policy. If you believe that Global has not adhered to this Policy, please contact Global at: Global Health & Safety LLC, 825 W Sandy Lake Rd Ste 190, Coppell, Texas 75019.'}

            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginTop: spacing,
            }}>{'Email Address:'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginBottom: spacing
            }}>{'info@ghscompanies.com'}</span>

            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginTop: spacing,
            }}>{'Telephone number:'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginBottom: spacing
            }}>{'+1 (972) 393-5500'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginTop: spacing,
            }}>{'Effective as of June 30, 2025'}</span>
        </span>
        </>
    )
}

export default FlipChartPrivacyPolicy;
